import React, { useState } from 'react';
import {
  Input,
  Checkbox,
  Card,
  DatePicker,
  InputNumber,
  Radio,
  Form,
  Row,
  Col,
  Collapse,
} from 'antd';
import UCheckBox from 'components/Checkbox';
import { CaretRightOutlined } from '@ant-design/icons';
import FormInput from 'components/FormInput';
import ParListSelect from 'components/ParListSelect';
import { FormInstance } from 'antd/lib/form';
import {
  OnlyIntegerNumber,
  shouldUpdateCompare,
  toDatePickerDate,
} from 'utils/utils2';
import InputRate from 'components/InputRate';
import ThirdPartyInput from 'components/ThirdPartyInput';
import Text from 'antd/lib/typography/Text';
import Value from 'components/Value';
import BrokerList from 'components/BrokerList';
import BranchList from 'components/BranchList';
import { isInteger } from 'lodash';
import UtinaCard from 'components/UtinaCard';
import { useQuery } from 'react-query';
import { getParList } from 'services/parametersService';
import StatusHistoryPopover from 'components/StatusHistoryPopover';
import UtinaPanel from 'components/UtinaPanel/UtinaPanel';
import GetLabel from 'DisplayFramework/components/GetLabel';
import moment from 'moment';

export type ThirdPartyGeneralDataProps = {
  form: FormInstance;
  tpid: String;
  gettptype: (tp: any) => void;
};
const { Panel } = Collapse;

const GeneralDataCard = ({
  tpid,
  form,
  gettptype,
}: ThirdPartyGeneralDataProps) => {
  const [TptypeParam, setTptypeParam] = useState('TPTYPE');
  const [TpFlagclient, setTpFlagclient] = useState(false);
  const [TpClienttype, setTpClienttype] = useState('');

  const { data: tptype } = useQuery(['getParList', TptypeParam], () =>
    getParList({ parcode: TptypeParam, tpid: 0 }).then((res) => res.list || [])
  );

  const [error, setError] = useState(false);
  const [parvalueexternal, setParvalueexternal] = useState('');

  const formatFrenchPhoneNumber = (
    value: any,
    prevValue = '',
    maxLength = 12 // +33 X XX XX XX XX = 12 digits excluding the '+'
  ) => {
    // Step 1: Remove all non-numeric characters except '+'
    let normalized = value.replace(/[^\d+]/g, '');

    // Step 3: Limit the length of the number to maxLength
    if (normalized.length > maxLength + 3) {
      normalized = normalized.slice(0, maxLength + 3); // +3 accounts for '+33'
    }

    // Step 4: Validate digits only (after +33)
    const digits = normalized.slice(3).replace(/[^\d]/g, '');
    if (!/^[0-9]*$/.test(digits)) {
      return prevValue; // Return the previous valid value if invalid
    }

    // Step 5: Format the number as +33 X XX XX XX XX
    return normalized.replace(
      /(\+33)(\d)(\d{2})(\d{2})(\d{2})(\d{2})/,
      '$1 $2 $3 $4 $5 $6'
    );
  };

  const shouldAutoFillLegalCaseDate = (value: any) => {
    return value=== '9' || value === '3' || value === '1' || value === '2';
  };

  return (
    <Collapse
      bordered={false}
      defaultActiveKey={['1', '2', '3']}
      expandIcon={({ isActive }) => (
        <CaretRightOutlined
          style={{ fontSize: 24 }}
          rotate={isActive ? 90 : 0}
        />
      )}
      expandIconPosition="left"
      //style={{ marginBottom: 24,overflow:'hidden',backgroundColor:'#f7f7f7',border:0,borderRadius:2  }}
    >
      <UtinaPanel
        comcode="generaldataTitle"
        key="1"
        style={{
          marginBottom: 24,
          overflow: 'hidden',
          background: '#f7f7f7',
          border: 10,
          borderRadius: 2,
          boxShadow:
            'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        }}
      >
        <Form.Item shouldUpdate={shouldUpdateCompare('tptype')} noStyle>
          {({ getFieldValue }) => {
            return getFieldValue('tptype') === 'PART' ? (
              <Card>
                <Row gutter={16}>
                  <FormInput col xs={2} name="tpreference">
                    <Value />
                  </FormInput>
                  <Form.Item shouldUpdate={() => true} noStyle>
                    {!tpid ? (
                      <Form.Item shouldUpdate={() => true} noStyle>
                        <FormInput col xs={4} name="tptype">
                          <Radio.Group
                            buttonStyle="solid"
                            disabled={Number(tpid) >= 0 ? true : false}
                            onChange={(e) => gettptype(e.target.value)}
                          >
                            {tptype?.map(({ parvalue, parlistlabel }, i) => (
                              <Radio.Button value={parvalue} key={i}>
                                {parlistlabel}
                              </Radio.Button>
                            ))}
                          </Radio.Group>
                        </FormInput>
                      </Form.Item>
                    ) : (
                      <FormInput col xs={3} name="tptypelabel">
                        <Value />
                      </FormInput>
                    )}
                  </Form.Item>
                  <StatusHistoryPopover
                    objectid={tpid ? tpid : (null as any)}
                    entity="THIRDPARTY"
                  >
                    <FormInput
                      col
                      xs={3}
                      name="tpstatuslabelgeneraldata"
                      comcode="overallStatus"
                    >
                      <Value />
                    </FormInput>
                  </StatusHistoryPopover>

                  <FormInput
                    col
                    xs={3}
                    name="tpflagclient"
                    valuePropName="checked"
                  >
                    <Checkbox
                      disabled={!!tpid}
                      onChange={(e) => {
                        setTpFlagclient(e.target.checked);
                      }}
                    />
                  </FormInput>
                  <FormInput
                    col
                    xs={3}
                    name="tpflagsupplier"
                    valuePropName="checked"
                  >
                    <Checkbox
                      disabled={!!tpid}
                      onChange={(e) => {
                        // if (e.target.checked) {
                        //   setTptypeParam('SPTYPE');
                        // } else {
                        setTptypeParam('TPTYPE');
                        // }
                      }}
                    />
                  </FormInput>
                  <FormInput
                    col
                    xs={3}
                    name="tpflagguarantor"
                    valuePropName="checked"
                  >
                    <Checkbox disabled={!!tpid} />
                  </FormInput>
                  <FormInput col xs={3} name="tproleother">
                    <ParListSelect parcode="TPOTHROLE" disabled={!!tpid} />
                  </FormInput>
                </Row>
                <Row gutter={16}>
                  <UtinaCard
                    level={5}
                    comcode="ThirdPartyInfo"
                    style={{ color: '#000' }}
                    lg={10}
                    additionalAttribute
                  >
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpgender">
                        <Radio.Group>
                          <Radio value="M">
                            <GetLabel label="Male" />
                          </Radio>
                          <Radio value="F">
                            <GetLabel label="Female" />{' '}
                          </Radio>
                        </Radio.Group>
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpclienttype"
                        rules={[{ required: TpFlagclient ? true : false }]}
                      >
                        <ParListSelect
                          parcode="TEN"
                          onChange={(e) => {
                            setTpClienttype(e);
                          }}
                        />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpsalutationcode">
                        <ParListSelect parcode="TPSALUT" />
                      </FormInput>
                    </Form.Item>
                    <Form.Item name="tpname" noStyle>
                      <FormInput col xs={12} name="tpname">
                        <Input
                          disabled={Number(tpid) >= 0 ? true : false}
                        ></Input>
                      </FormInput>
                    </Form.Item>

                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} name="tpsurname">
                        <Input
                          disabled={Number(tpid) >= 0 ? true : false}
                        ></Input>
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpbirthdate">
                        <DatePicker />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpbirthcountry">
                        <ParListSelect
                          parcode="COUNTRY"
                          onSelectedObj={(e) => {
                            form.setFieldsValue({ tpidentitycardid: '' });
                          }}
                        />
                      </FormInput>
                    </Form.Item>

                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpbirthcity">
                        <Input />
                      </FormInput>
                    </Form.Item>

                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpnationality"
                        rules={[
                          {
                            required:
                              TpFlagclient || TpClienttype === '2'
                                ? true
                                : false,
                          },
                        ]}
                      >
                        <ParListSelect parcode="TER" />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpidentitycardtype">
                        <ParListSelect
                          parcode="CARDTYPE"
                          onSelectedObj={(e) => {
                            form.setFieldsValue({ tpidentitycardid: '' });
                            setParvalueexternal(e.parvalueexternal);
                          }}
                        />
                      </FormInput>
                    </Form.Item>

                    <Form.Item
                      noStyle
                      shouldUpdate={shouldUpdateCompare('tptype')}
                    >
                      <FormInput
                        col
                        xs={12}
                        name="tpidentitycardid"
                        rules={[
                          {
                            validator: (_, value) => {
                              if (!value) {
                                return Promise.resolve();
                              }
                              if (!parvalueexternal) {
                                return Promise.resolve();
                              }

                              const firstChar = parvalueexternal.substring(
                                0,
                                1
                              );
                              const nbrchar = parvalueexternal.length;

                              if (firstChar === 'S') {
                                const regex = new RegExp(
                                  `^[A-Z]\\d{${nbrchar - 1}}$`
                                );
                                if (!regex.test(value)) {
                                  return Promise.reject(
                                    new Error(
                                      `ID must start with an uppercase letter followed by ${
                                        nbrchar - 1
                                      } digits.`
                                    )
                                  );
                                }
                              } else if (firstChar === 'X') {
                                const regex = new RegExp(`^\\d{${nbrchar}}$`);
                                if (!regex.test(value)) {
                                  return Promise.reject(
                                    new Error(
                                      `ID must be exactly ${nbrchar} digits.`
                                    )
                                  );
                                }
                              }

                              return Promise.resolve();
                            },
                          },
                        ]}
                        placeholderprops={
                          parvalueexternal ? parvalueexternal : undefined
                        }
                        normalize={(input: string) => input.toUpperCase()}
                      >
                        <Input
                          maxLength={
                            parvalueexternal
                              ? parvalueexternal.length
                              : undefined
                          }
                          onKeyPress={(e) => {
                            if (!parvalueexternal) {
                              return;
                            }
                            const firstChar = parvalueexternal.substring(0, 1);

                            if (firstChar === 'S') {
                              const valueLength = e.currentTarget.value.length;

                              if (valueLength > 0 && !/\d/.test(e.key)) {
                                e.preventDefault();
                              }
                            } else if (firstChar === 'X') {
                              if (!/\d/.test(e.key)) {
                                e.preventDefault();
                              }
                            }
                          }}
                        />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpidentitycardcountry"
                      >
                        <ParListSelect parcode="COUNTRY" />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpidentitycardexpirationdate"
                      >
                        <DatePicker />
                      </FormInput>
                    </Form.Item>
                    <FormInput
                      col
                      xs={12}
                      name="tpflagresident"
                      valuePropName="checked"
                      initialValue
                    >
                      <Checkbox defaultChecked />
                    </FormInput>
                  </UtinaCard>

                  <UtinaCard
                    level={5}
                    comcode="OthersInfo"
                    style={{ color: '#000' }}
                    lg={8}
                    additionalAttribute
                  >
                    <FormInput col xs={12} lg={12} name="lancode">
                      <ParListSelect allowClear parcode="LANCODE" />
                    </FormInput>
                    <FormInput col xs={12} lg={12} name="countcode">
                      <ParListSelect
                        allowClear
                        parcode="COUNTRY"
                        onChange={(e) => {
                          form.setFieldsValue({ tpfiscalcity: '' });
                        }}
                      />
                    </FormInput>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpmaritalstatus">
                        <ParListSelect allowClear parcode="TPMARSTAT" />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <>
                        <FormInput col xs={12} lg={12} name="tpnbofchildren">
                          <InputNumber
                            formatter={(value) => {
                              if (
                                isNaN(Number(value)) ||
                                !isInteger(Number(value))
                              ) {
                                setError(true);
                                return ``;
                              } else {
                                setError(false);
                                return `${value}`;
                              }
                            }}
                            max={10}
                            min={0}
                            step={1}
                          />
                        </FormInput>
                        {error && (
                          <Col>
                            <p
                              role="alert"
                              style={{
                                color: 'rgb(255, 0, 0)',
                                paddingTop: '15%',
                              }}
                            >
                              Please make sure you've entered a <em>number</em>
                            </p>
                          </Col>
                        )}
                      </>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpactivitysector">
                        <ParListSelect
                          parcode="TPSECACTIV"
                          onChange={(e) => {
                            form.setFieldsValue({ tpactivity: '' });
                          }}
                        />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare([
                        'tptype',
                        'tpactivitysector',
                      ])}
                      noStyle
                    >
                      {({ getFieldValue }) => (
                        <FormInput col xs={12} lg={12} name="tpactivity">
                          <ParListSelect
                            parcode="TPACTIVITY"
                            parvalueparent={getFieldValue('tpactivitysector')}
                          />
                        </FormInput>
                      )}
                    </Form.Item>

                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpcategory">
                        <ParListSelect parcode="TPCATEGORY" />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpprofession">
                        <ParListSelect parcode="PROFESSION" />
                      </FormInput>
                    </Form.Item>

                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpworkingcttype">
                        <ParListSelect parcode="WORKCTTYPE" />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpworkingctdate">
                        <DatePicker />
                      </FormInput>
                    </Form.Item>

                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpprotype"
                        rules={[
                          {
                            required:
                              TpFlagclient || TpClienttype === '2'
                                ? true
                                : false,
                          },
                        ]}
                      >
                        <ParListSelect parcode="TPP" />
                      </FormInput>
                    </Form.Item>
                  </UtinaCard>

                  <UtinaCard
                    level={5}
                    comcode="FiscalInfo"
                    style={{ color: '#000' }}
                    lg={4}
                    additionalAttribute
                  >
                    <FormInput col xs={24} name="tpfiscalid" />
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare([
                        'tptype',
                        'countcode',
                      ])}
                      noStyle
                    >
                      {({ getFieldValue }) => (
                        <FormInput col xs={24} name="tpfiscalcity">
                          <ParListSelect
                            parcode="TRIBUNAL"
                            parvalueparent={getFieldValue('countcode')}
                          />
                        </FormInput>
                      )}
                    </Form.Item>
                    <FormInput col xs={24} name="tptaxid" />
                    <FormInput
                      col
                      xs={24}
                      name="tpflagvatexemption"
                      valuePropName="checked"
                      noStyle
                    >
                      <UCheckBox comcode="tpflagvatexemption" />
                    </FormInput>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tpflagvatexemption')}
                    >
                      {({ getFieldValue }) => {
                        return getFieldValue('tpflagvatexemption') ? (
                          <FormInput name="tpvatexemtionenddate">
                            <DatePicker />
                          </FormInput>
                        ) : (
                          ''
                        );
                      }}
                    </Form.Item>
                    <FormInput
                      col
                      xs={24}
                      name="tptradingid"
                      normalize={(
                        value: string,
                        prevValue: any,
                        allvalues: any
                      ) => OnlyIntegerNumber(value, prevValue, allvalues, 15)}
                    />

                    <FormInput
                      col
                      xs={24}
                      name="tpcompanyid"
                      normalize={(
                        value: string,
                        prevValue: any,
                        allvalues: any
                      ) => OnlyIntegerNumber(value, prevValue, allvalues, 50)}
                    />
                  </UtinaCard>
                </Row>
              </Card>
            ) : (
              <Card>
                <Row gutter={16}>
                  <FormInput col xs={2} name="tpreference">
                    <Value />
                  </FormInput>
                  {!tpid ? (
                    <Form.Item shouldUpdate={() => true} noStyle>
                      <FormInput col xs={4} name="tptype">
                        <Radio.Group
                          buttonStyle="solid"
                          disabled={Number(tpid) >= 0 ? true : false}
                          onChange={(e) => gettptype(e.target.value)}
                        >
                          {tptype?.map(({ parvalue, parlistlabel }, i) => (
                            <Radio.Button value={parvalue} key={i}>
                              {parlistlabel}
                            </Radio.Button>
                          ))}
                        </Radio.Group>
                      </FormInput>
                    </Form.Item>
                  ) : (
                    <FormInput col xs={3} name="tptype">
                      {form.getFieldValue('tptype') === 'PART' ? (
                        <Text>Individual</Text>
                      ) : (
                        <Text>Company</Text>
                      )}
                    </FormInput>
                  )}
                  <StatusHistoryPopover
                    objectid={tpid ? tpid : (null as any)}
                    entity="THIRDPARTY"
                  >
                    <FormInput
                      col
                      xs={3}
                      name="tpstatuslabelgeneraldata"
                      comcode="overallStatus"
                    >
                      <Value />
                    </FormInput>
                  </StatusHistoryPopover>
                  <FormInput
                    col
                    xs={3}
                    name="tpflagclient"
                    valuePropName="checked"
                  >
                    <Checkbox disabled={!!tpid} />
                  </FormInput>
                  <FormInput
                    col
                    xs={3}
                    name="tpflagsupplier"
                    valuePropName="checked"
                  >
                    <Checkbox disabled={!!tpid} />
                  </FormInput>
                  <FormInput
                    col
                    xs={3}
                    name="tpflagguarantor"
                    valuePropName="checked"
                  >
                    <Checkbox disabled={!!tpid} />
                  </FormInput>
                  <FormInput col xs={3} name="tproleother">
                    <ParListSelect parcode="TPOTHROLE" disabled={!!tpid} />
                  </FormInput>
                </Row>
                <Row gutter={16}>
                  <UtinaCard
                    level={5}
                    comcode="ThirdPartyInfo"
                    style={{ color: '#000' }}
                    lg={10}
                    additionalAttribute
                  >
                    <Form.Item name="tpname" noStyle>
                      <FormInput col xs={12} name="tpname">
                        <Input
                          disabled={Number(tpid) >= 0 ? true : false}
                        ></Input>
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} name="tpmarketingname" />
                    </Form.Item>

                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpactivitysector">
                        <ParListSelect
                          parcode="TPSECACTIV"
                          onChange={(e) => {
                            form.setFieldsValue({ tpactivity: '' });
                          }}
                        />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare([
                        'tptype',
                        'tpactivitysector',
                      ])}
                      noStyle
                    >
                      {({ getFieldValue }) => (
                        <FormInput col xs={12} lg={12} name="tpactivity">
                          <ParListSelect
                            parcode="TPACTIVITY"
                            parvalueparent={getFieldValue('tpactivitysector')}
                          />
                        </FormInput>
                      )}
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tplegalform">
                        <ParListSelect
                          parcode="LEGALFORM"
                          onChange={() => {
                            form.setFieldsValue({
                              tpspecificidentifier: '',
                            });
                          }}
                        />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare([
                        'tptype',
                        'tplegalform',
                        'tptaxid',
                        'tpfiscalcity',
                      ])}
                      noStyle
                    >
                      {({ getFieldValue }) => {
                        const legalform = getFieldValue('tplegalform');
                        const tpfiscalcity =
                          getFieldValue('tpfiscalcity') !== undefined
                            ? getFieldValue('tpfiscalcity')
                            : '';
                        const tptaxid =
                          getFieldValue('tptaxid') !== undefined
                            ? getFieldValue('tptaxid')
                            : '';

                        const requiredLegalForms = [
                          11, 21, 22, 24, 25, 26, 27, 28, 35, 36, 40, 95,
                        ];
                        const isSpecificRequired = requiredLegalForms.includes(
                          Number(legalform)
                        );

                        const specificIdentifierRules = [
                          {
                            validator: async (_: any, value: any) => {
                              const legalFormValue =
                                getFieldValue('tplegalform');
                              const legalFormStr =
                                legalFormValue === null ||
                                legalFormValue === undefined
                                  ? ''
                                  : String(legalFormValue);

                              const isComputedSpecificId =
                                requiredLegalForms.includes(
                                  Number(legalFormStr)
                                );

                              if (isComputedSpecificId) {
                                const currentTaxId =
                                  getFieldValue('tptaxid') ?? '';
                                const currentFiscalCity =
                                  getFieldValue('tpfiscalcity') ?? '';
                                const computedSpecificId = `${currentTaxId}${currentFiscalCity}`;

                                if (!computedSpecificId) {
                                  return Promise.resolve();
                                }

                                if (String(value ?? '') !== computedSpecificId) {
                                  return Promise.reject(
                                    new Error(
                                      'Identifiant spécifique non compatible avec la forme juridique sélectionnée.'
                                    )
                                  );
                                }

                                return Promise.resolve();
                              }

                              const isListDrivenSpecificId = [
                                '23',
                                '30',
                                '41',
                                '50',
                                '60',
                                '70',
                                '71',
                                '80',
                              ].includes(legalFormStr);

                              if (isListDrivenSpecificId) {
                                if (value === undefined || value === null || value === '') {
                                  return Promise.reject(
                                    new Error(
                                      'Identifiant spécifique requis pour la forme juridique sélectionnée.'
                                    )
                                  );
                                }
                              }

                              return Promise.resolve();
                            },
                          },
                        ];

                        if (isSpecificRequired) {
                          const computedSpecificId = `${tptaxid}${tpfiscalcity}`;
                          const currentSpecificId = getFieldValue(
                            'tpspecificidentifier'
                          );
                          if (currentSpecificId !== computedSpecificId) {
                            form.setFieldsValue({
                              tpspecificidentifier: computedSpecificId,
                            });
                          }
                        }

                        return isSpecificRequired ? (
                          <FormInput
                            col
                            xs={12}
                            lg={12}
                            name="tpspecificidentifier"
                            rules={specificIdentifierRules}
                          >
                            <Text>{tptaxid + tpfiscalcity}</Text>
                          </FormInput>
                        ) : legalform === '23' ? (
                          <FormInput
                            col
                            xs={12}
                            lg={12}
                            name="tpspecificidentifier"
                            rules={specificIdentifierRules}
                          >
                            <ParListSelect parcode="ASS" />
                          </FormInput>
                        ) : legalform === '30' ? (
                          <FormInput
                            col
                            xs={12}
                            lg={12}
                            name="tpspecificidentifier"
                            rules={specificIdentifierRules}
                          >
                            <ParListSelect parcode="COP" />
                          </FormInput>
                        ) : legalform === '41' ? (
                          <FormInput
                            col
                            xs={12}
                            lg={12}
                            name="tpspecificidentifier"
                            rules={specificIdentifierRules}
                          >
                            <ParListSelect parcode="SCI" />
                          </FormInput>
                        ) : legalform === '50' ? (
                          <FormInput
                            col
                            xs={12}
                            lg={12}
                            name="tpspecificidentifier"
                            rules={specificIdentifierRules}
                          >
                            <ParListSelect parcode="DIP" />
                          </FormInput>
                        ) : legalform === '60' ? (
                          <FormInput
                            col
                            xs={12}
                            lg={12}
                            name="tpspecificidentifier"
                            rules={specificIdentifierRules}
                          >
                            <ParListSelect parcode="INT" />
                          </FormInput>
                        ) : legalform === '70' || legalform === '71' ? (
                          <FormInput
                            col
                            xs={12}
                            lg={12}
                            name="tpspecificidentifier"
                            rules={specificIdentifierRules}
                          >
                            <ParListSelect parcode="EEP" />
                          </FormInput>
                        ) : legalform === '80' ? (
                          <FormInput
                            col
                            xs={12}
                            lg={12}
                            name="tpspecificidentifier"
                            rules={specificIdentifierRules}
                          >
                            <ParListSelect parcode="ISB" />
                          </FormInput>
                        ) : (
                          <FormInput
                            col
                            xs={12}
                            lg={12}
                            name="tpspecificidentifier"
                            rules={specificIdentifierRules}
                          >
                            <Input />
                          </FormInput>
                        );
                      }}
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tpcompanycreationdate"
                      >
                        <DatePicker />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpcapital" />
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpcategory">
                        <ParListSelect parcode="TPCATEGORY" />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpcompanysize">
                        <ParListSelect parcode="TPCOMSIZE" />
                      </FormInput>
                    </Form.Item>
                    <FormInput
                      col
                      xs={12}
                      name="tpflagresident"
                      initialValue
                      valuePropName="checked"
                    >
                      <Checkbox defaultChecked />
                    </FormInput>
                  </UtinaCard>

                  <UtinaCard
                    level={5}
                    comcode="OthersInfo"
                    lg={8}
                    additionalAttribute
                  >
                    <FormInput col xs={12} lg={12} name="lancode">
                      <ParListSelect allowClear parcode="LANCODE" />
                    </FormInput>
                    <FormInput col xs={12} lg={12} name="countcode">
                      <ParListSelect
                        allowClear
                        parcode="COUNTRY"
                        onChange={(e) => {
                          form.setFieldsValue({ tpfiscalcity: '' });
                        }}
                      />
                    </FormInput>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpmanagername" />
                    </Form.Item>

                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpmanagerposition">
                        <ParListSelect parcode="TPMANPOS" />
                      </FormInput>
                    </Form.Item>

                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={24} md={24} name="parentCompany">
                        <ThirdPartyInput role="" />
                      </FormInput>
                    </Form.Item>

                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpcapitalholding">
                        <InputRate defaultValue={0} min={0} />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tprevenue">
                        <InputNumber defaultValue={0} min={0} />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput
                        col
                        xs={12}
                        lg={12}
                        name="tprevenuereferenceyear"
                      >
                        <DatePicker />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpupdatetype">
                        <ParListSelect
                          parcode="NMD"
                          onChange={(e) => {
                            if (e === '0') {
                              form.setFieldsValue({
                                tpupdatedate: '',
                              });
                            } else {
                              form.setFieldsValue({
                                tpupdatedate: toDatePickerDate(
                                  moment(Date.now()).format('YYYY-MM-DD')
                                ),
                              });
                            }
                          }}
                        />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tpupdatedate">
                        <DatePicker />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tplegalcasedate">
                        <DatePicker />
                      </FormInput>
                    </Form.Item>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tptype')}
                      noStyle
                    >
                      <FormInput col xs={12} lg={12} name="tplegalcasestatus">
                        <ParListSelect
                          parcode="EPJ"
                          onChange={(value) => {
                            console.log('value', value);
                            if (shouldAutoFillLegalCaseDate(value)) {
                              form.setFieldsValue({
                                tplegalcasedate: toDatePickerDate(
                                  moment(Date.now()).format('YYYY-MM-DD')
                                ),
                              });
                            }
                            else
                            {
                              form.setFieldsValue({
                                tplegalcasedate: '',
                              });
                            }
                          }}
                       
                        />
                      </FormInput>
                    </Form.Item>
                  </UtinaCard>

                  <UtinaCard
                    level={5}
                    comcode="FiscalInfo"
                    style={{ color: '#000' }}
                    lg={4}
                    additionalAttribute
                  >
                    <FormInput col xs={24} name="tpfiscalid" />
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare([
                        'tptype',
                        'countcode',
                      ])}
                      noStyle
                    >
                      {({ getFieldValue }) => (
                        <FormInput col xs={24} name="tpfiscalcity">
                          <ParListSelect
                            parcode="TRIBUNAL"
                            parvalueparent={getFieldValue('countcode')}
                          />
                        </FormInput>
                      )}
                    </Form.Item>
                    <FormInput col xs={24} name="tptaxid" />
                    <FormInput
                      col
                      xs={24}
                      name="tpflagvatexemption"
                      valuePropName="checked"
                      noStyle
                    >
                      <UCheckBox comcode="tpflagvatexemption" />
                    </FormInput>
                    <Form.Item
                      shouldUpdate={shouldUpdateCompare('tpflagvatexemption')}
                      noStyle
                    >
                      {({ getFieldValue }) => {
                        return getFieldValue('tpflagvatexemption') ? (
                          <FormInput name="tpvatexemtionenddate" col xs={24}>
                            <DatePicker />
                          </FormInput>
                        ) : (
                          ''
                        );
                      }}
                    </Form.Item>
                    <FormInput
                      col
                      xs={24}
                      name="tptradingid"
                      normalize={(
                        value: string,
                        prevValue: any,
                        allvalues: any
                      ) => OnlyIntegerNumber(value, prevValue, allvalues, 15)}
                    />

                    <FormInput
                      col
                      xs={24}
                      name="tpcompanyid"
                      normalize={(
                        value: string,
                        prevValue: any,
                        allvalues: any
                      ) => OnlyIntegerNumber(value, prevValue, allvalues, 50)}
                    />
                  </UtinaCard>
                </Row>
              </Card>
            );
          }}
        </Form.Item>
      </UtinaPanel>
      <UtinaPanel
        comcode="contact"
        key="2"
        style={{
          marginBottom: 24,
          overflow: 'hidden',
          background: '#f7f7f7',
          border: 10,
          borderRadius: 2,
          boxShadow:
            'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        }}
      >
        <Card>
          <Row gutter={16}>
            <UtinaCard
              level={5}
              comcode="primary-contact"
              lg={11}
              style={{ color: '#000' }}
              additionalAttribute
            >
              <FormInput col xs={12} name="tpcontactname1" />
              <FormInput col xs={12} name="tpcontactposition1">
                <ParListSelect parcode="TPMANPOS" />
              </FormInput>
              <FormInput
                col
                xs={12}
                name="tptel1"
                normalize={
                  (value: string, prevValue: any, allvalues: any) =>
                    formatFrenchPhoneNumber(value, prevValue, 12)
                  // normalizeFrenchPhoneNumber(value)
                }
              />

              <FormInput
                col
                xs={12}
                name="tptelmobile1"
                normalize={(value: string, prevValue: any, allvalues: any) =>
                  OnlyIntegerNumber(value, prevValue, allvalues, 15)
                }
              />
              <FormInput col xs={24} name="tpemail1" />
            </UtinaCard>

            <UtinaCard
              level={5}
              comcode="secondary-contact"
              style={{ color: '#000' }}
              lg={11}
              additionalAttribute
            >
              <FormInput col xs={12} name="tpcontactname2" />
              <FormInput col xs={12} name="tpcontactposition2">
                <ParListSelect parcode="TPMANPOS" />
              </FormInput>
              <FormInput
                col
                xs={12}
                name="tptel2"
                normalize={(value: string, prevValue: any, allvalues: any) =>
                  OnlyIntegerNumber(value, prevValue, allvalues, 15)
                }
              />
              <FormInput
                col
                xs={12}
                name="tptelmobile2"
                normalize={(value: string, prevValue: any, allvalues: any) =>
                  OnlyIntegerNumber(value, prevValue, allvalues, 15)
                }
              />
              <FormInput col xs={24} name="tpemail2" />
            </UtinaCard>
          </Row>
        </Card>
      </UtinaPanel>
      <UtinaPanel
        comcode="origin"
        key="3"
        style={{
          marginBottom: 24,
          overflow: 'hidden',
          background: '#f7f7f7',
          border: 10,
          borderRadius: 2,
          boxShadow:
            'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        }}
      >
        <Card size="small">
          <Row gutter={[50, 0]}>
            <FormInput col xs={4} name="tporigin">
              <ParListSelect parcode="TPORIGIN" />
            </FormInput>

            <FormInput col xs={4} name="tpspecialtag">
              <ParListSelect parcode="TPTAG" />
            </FormInput>

            <FormInput col xs={4} name="tpbrokerid">
              <BrokerList
                params={{
                  mgid: Number(
                    form.getFieldValue('mgid')
                      ? form.getFieldValue('mgid')
                      : localStorage.getItem('mgid')
                  ),
                }}
                onSelected={(e) =>
                  form?.setFieldsValue({
                    brokerstatus: e?.brokerstatus ?? 'ACTIVE',
                  })
                }
              />
            </FormInput>

            <FormInput col xs={4} name="tpbranchid">
              <BranchList
                params={{
                  mgid: Number(
                    form.getFieldValue('mgid')
                      ? form.getFieldValue('mgid')
                      : localStorage.getItem('mgid')
                  ),
                  channelcode: '',
                  brname: '',
                }}
              />
            </FormInput>
          </Row>
        </Card>
      </UtinaPanel>

      <UtinaPanel
        comcode="consent"
        key="4"
        style={{
          marginBottom: 24,
          overflow: 'hidden',
          background: '#f7f7f7',
          border: 10,
          borderRadius: 2,
          boxShadow:
            'rgba(50, 50, 93, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px',
        }}
      >
        <Card size="small">
          <Row gutter={[8, 8]}>
            <FormInput
              col
              xs={4}
              name="tpflagconsentmain"
              valuePropName="checked"
              noStyle
            >
              <UCheckBox comcode="tpflagconsentmain" />
            </FormInput>
            <Col span={20}>
              <FormInput
                col
                xs={4}
                name="tpflagconsent2"
                valuePropName="checked"
                noStyle
              >
                <UCheckBox comcode="tpflagconsent2" />
              </FormInput>
              <FormInput
                col
                xs={4}
                name="tpflagconsent3"
                valuePropName="checked"
                noStyle
              >
                <UCheckBox comcode="tpflagconsent3" />
              </FormInput>
              <FormInput
                col
                xs={4}
                name="tpflagconsent4"
                valuePropName="checked"
                noStyle
              >
                <UCheckBox comcode="tpflagconsent4" />
              </FormInput>
              <FormInput
                col
                xs={4}
                name="tpflagconsent5"
                valuePropName="checked"
                noStyle
              >
                <UCheckBox comcode="tpflagconsent5" />
              </FormInput>
            </Col>
          </Row>
        </Card>
      </UtinaPanel>
    </Collapse>
  );
};

export default GeneralDataCard;
